import React, { FC } from 'react'
import styles from './styles.module.scss'
import * as Styles from '../styles'
import { SparklesIcon } from '../../../../../uiKit/icons/SparklesIcon'
import * as LocalStyles from './styles'
import { TrainButtonState } from '../util/button'
import ModalTemplate from '../../../../../uiKit/ModalTemplate'
import { useUnknownQuestions } from '../context'
import { UnknownQuestionModel } from '../types'

type TrainQuestionModalDialogProps = {
  question: UnknownQuestionModel
  canBeTrained: boolean
  onClose: () => void
}

export const TrainQuestionModalDialog: FC<TrainQuestionModalDialogProps> = ({ question, canBeTrained, onClose }) => {
  const { trainQuestion } = useUnknownQuestions()

  const doShowFollowUpButton = !!question?.whoAsked && !question.trainedOnce

  const onTrainButtonPressed = async (followUp = false) => {
    if (!canBeTrained) return

    try {
      await trainQuestion(question, { id: question.id, followUp })
    } finally {
      onClose()
    }
  }

  return (
    <ModalTemplate
      containerClasses={styles.modal}
      open
      title="Train question"
      titleIcon={
        <Styles.TitleIconWrapper>
          <SparklesIcon />
        </Styles.TitleIconWrapper>
      }
      onClose={onClose}
      withFooter={false}>
      <Styles.ModalContainer>
        <Styles.SubHeader>
          Do you want to train the question? Bot will reply to similar questions with provided answer
        </Styles.SubHeader>

        <Styles.ModalButtonContainer>
          <LocalStyles.CancelButton onClick={onClose}>Cancel</LocalStyles.CancelButton>

          <LocalStyles.ModalButton
            onClick={() => onTrainButtonPressed()}
            state={canBeTrained ? TrainButtonState.ACTIVE : TrainButtonState.INACTIVE}>
            Train
          </LocalStyles.ModalButton>

          {doShowFollowUpButton && (
            <LocalStyles.ModalButton
              onClick={() => onTrainButtonPressed(true)}
              state={canBeTrained ? TrainButtonState.ACTIVE : TrainButtonState.INACTIVE}>
              Train and Follow Up
            </LocalStyles.ModalButton>
          )}
        </Styles.ModalButtonContainer>
      </Styles.ModalContainer>
    </ModalTemplate>
  )
}
